import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: "Helpdesk's Time",
	url: '/managers/helpdesk_time_tracking',
	icon: 'dashboard'
}];

export default class HelpDeskTimeTracking extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.HelpDeskTimeTracking history={history} />
					</div>
				</div>
			</div>
		)
	}
}
